import {useState} from 'react';
import {AwesomeButton} from 'react-awesome-button';
import 'react-awesome-button/dist/styles.css';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './redEasyButton.css';
import EngageAlignSimplifyYieldComponent from '@modules/home/main/modules-menu/engage-align-simplify-yield/EngageAlignSimplifyYieldComponent';

const RedEasyButtonComponent = props => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleButtonPress = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="easy-button-wrapper">
      <AwesomeButton type="danger" onPress={handleButtonPress}>
        easy
      </AwesomeButton>

      <Dialog
        open={open}
       
        fullScreen={isSmallScreen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">
          <Typography variant="h4" sx={{fontSize: '1.5em !important'}}>
            Reach out to Management
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme => theme.palette.grey[500]
            }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            px: {xs: 1.5, sm: 3},
            pb: {xs: 2, sm: 3},
          }}>
          <EngageAlignSimplifyYieldComponent setOpen={setOpen} />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default RedEasyButtonComponent;
